import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Plane } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) { toast.success("Account created."); nav("/portal"); }
    else setErr(res.error);
  };
  const inp = "w-full bg-[#FAF7F0] border border-[#E5DFD2] focus:border-[#A47E2A] focus:outline-none px-4 py-3 rounded-sm text-[#1A1D24] transition-colors";

  return (
    <div className="min-h-screen bg-[#FAF7F0] flex text-[#1A1D24]">
      <div className="hidden md:block md:w-1/2 relative">
        <img src="https://images.pexels.com/photos/14914172/pexels-photo-14914172.jpeg?auto=compress&cs=tinysrgb&w=1400" className="w-full h-full object-cover" alt=""/>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1D24] via-[#1A1D24]/40 to-[#1A1D24]/10"/>
      </div>
      <div className="w-full md:w-1/2 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <Plane size={18} className="as-gold" strokeWidth={1.5}/>
            <span className="as-serif text-xl">AeroSphere <span className="as-gold">Global</span></span>
          </Link>
          <div className="as-overline mb-3">Open Client Account</div>
          <h1 className="as-serif text-4xl md:text-5xl font-light">Welcome aboard.</h1>
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="register-form">
            <div>
              <div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] mb-2">Full name</div>
              <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className={inp} data-testid="register-name"/>
            </div>
            <div>
              <div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] mb-2">Email</div>
              <input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className={inp} data-testid="register-email"/>
            </div>
            <div>
              <div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] mb-2">Password</div>
              <input required type="password" minLength="6" value={form.password} onChange={e => setForm({...form, password: e.target.value})} className={inp} data-testid="register-password"/>
            </div>
            {err && <div className="text-sm text-[#FCA5A5]" data-testid="register-error">{err}</div>}
            <button disabled={loading} className="as-btn-gold w-full py-4 rounded-sm as-mono text-xs uppercase tracking-[0.2em] disabled:opacity-60" data-testid="register-submit">
              {loading ? "Creating…" : "Create Account"}
            </button>
          </form>
          <div className="mt-6 text-sm text-[#756E64]">
            Already have an account? <Link to="/login" className="text-[#A47E2A] hover:underline" data-testid="register-to-login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
